<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr data-field="bus_sos_enabled">
            <td align="right" width="500">Enabled</td>
            <td width="800"><b-form-select v-model="model.bus_sos_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_email_recipients">
            <td align="right" width="500">Email Recipients</td>
            <td width="800"><b-form-input v-model="model.bus_sos_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_sms_recipients">
            <td align="right" width="500">SMS Recipients</td>
            <td width="800"><b-form-input v-model="model.bus_sos_sms_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_max_miles_away">
            <td align="right" width="500">Range In Miles</td>
            <td width="800">
              <b-form-input v-model="model.bus_sos_max_miles_away" type="text" :state="numericState('bus_sos_max_miles_away')" @input="validateNumeric('bus_sos_max_miles_away', $event, 0, 500)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('bus_sos_max_miles_away')">{{ numericFeedback('bus_sos_max_miles_away') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_include_all_vehicles_with_matching_tag">
            <td align="right" width="500">Include Vehicles Matching Tag</td>
            <td width="800"><b-form-input v-model="model.bus_sos_include_all_vehicles_with_matching_tag" type="text" :state="filterState('bus_sos_include_all_vehicles_with_matching_tag')" @input="validateFilter('bus_sos_include_all_vehicles_with_matching_tag', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('bus_sos_include_all_vehicles_with_matching_tag')">{{ filterFeedback('bus_sos_include_all_vehicles_with_matching_tag') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_send_to_other_companies">
            <td align="right" width="500">Send To Other Companies</td>
            <td width="800"><b-form-select v-model="model.bus_sos_send_to_other_companies" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="bus_sos_receive_from_other_companies">
            <td align="right" width="500">Receive From Other Companies</td>
            <td width="800"><b-form-select v-model="model.bus_sos_receive_from_other_companies" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
        </table>


      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  <div class="tc-sticky-save">
    <transition name="tc-save-slide">
    <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
      <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
      <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
      &nbsp;&nbsp;
      <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
    </div>
    </transition>
  </div>
</div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, numericValidationMixin, dirtyTrackingMixin],
  components: {
  },

  data() {
    return {
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        if (dirtyKeys.size === 0) {
          this.$emit('showAlert', 'No changes to save', 'info', 3000)
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }

        await update_tenant_config_settings(this.user.tenant, payload)
        this._resetDirtyTracking()
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value, key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

